import { z } from 'zod';

export const meSchema = z.object({
  currentLicense: z.object({
    holderType: z.literal('TENANT').or(z.literal('USER')),
    plan: z.object({ features: z.array(z.object({ key: z.string() })) }),
  }),
  me: z.object({
    createdAt: z.string(),
    forceNewEditor: z.boolean().default(false),
  }),
  externalIntegrations: z.array(
    z.object({
      id: z.string(),
      displayName: z.string(),
      externalIntegrationSetting: z.object({
        displayName: z.string(),
        key: z.string(),
        integrationFeatures: z.array(z.string()),
      }),
    }),
  ),
});

export type Me = z.infer<typeof meSchema>;

export type ExternalIntegration = {
  id: string;
  userName: string;
  integrationName: string;
  integrationKey: string;
  features: string[];
};
